function Contacts() {
    return (
        <div className="container content"> 
            <h1 style={{textAlign: "center", color: "white"}}>Связаться с нами</h1>
            <div style={{textAlign: "center"}}>
                <a href="tel:+9213743175">Позвонить нам</a>
                <br />
                <br />
                <a href="mailto:maxxxim54@mail.ru">Отправить письмо</a>
            </div>
        </div>
    )
}

export default Contacts;